// Pricing constants for the application
export const PRICING = {
  PRO_PRICE: 149.99, // Limited time offer - regular $599
  REGULAR_PRICE: 599.00,
  CURRENCY: 'USD',
  CURRENCY_SYMBOL: '$'
};

// Helper function to format price
export const formatPrice = (price) => {
  return `${PRICING.CURRENCY_SYMBOL}${price.toFixed(2)}`;
};